import $ from 'jquery';

import { icon } from '../../../../../../../component/component'

export default function(o,p,data,updateTitles){

  var id = data.id

   var number =
    $('<span>')
    .html('1.')
    .css({
      fontSize: '8px',
      position: 'absolute',
      top: '12px',
      right: '20px',
      fomtSize: '10px',
      fontWeight: 'bold',
    })
    .hide()

  var up =
    icon('fi-arrow-up')
    .css({
      width: '16px',
      height: '16px',
      position: 'absolute',
      top: '7px',
      right: '7px',
    })
    .hide()

  var down =
    icon('fi-arrow-down')
    .css({
      width: '16px',
      height: '16px',
      position: 'absolute',
      top: '7px',
      right: '7px',
    })
    .hide()

  var update = function(){
    var sorter = _.find(p.sorters,{id:id})
    var index = _.findIndex(p.sorters,{id:id}) + 1
    if(!sorter){
      number.hide()
      down.hide()
      up.hide()
    } else if(sorter.direction == 'asc'){
      number.html(index+'.')
      number.show()
      down.show()
      up.hide()
    } else if(sorter.direction == 'desc'){
      number.html(index+'.')
      number.show()
      down.hide()
      up.show()
    }
  }

  var click = function(e){

    var sorter = _.find(p.sorters,{id:id})

    if(!sorter){
      p.sorters.push({
        id: id,
        direction: 'asc',
      })
    } else if(sorter.direction == 'asc'){
      sorter.direction = 'desc'
    } else {
      p.sorters = _.filter(p.sorters,function(s){
        console.log('filter', s)
        return s.id != id
      })
    }

    if(p.sorters.length){
      o.store(p.modelId+'TableSorters',p.sorters)
    } else {
      o.store.remove(p.modelId+'TableSorters')
    }

    updateTitles()
    p.update()

  }

  var div =
    $('<div>')
    .css({
      position: 'relative',
      padding: '8px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      height: '34px',
      display: 'block',
      color: 'white',
      borderBottom: '1px solid rgba(255,255,255,0.1)',
      paddingRight: '35px',
      cursor: 'pointer',
    })
    .attr({
      title: id,
    })
    .append(
      number,
      up,
      down,
      $('<span>').html(id),
    )
    .click(click)

  div.update = update

  update()

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/header/column/title/title.js